import React, { useEffect, useRef, useState } from "react";
import Layout from "../Layout/Layout";
import "../css/squads.css";
import ChatFriendList from "../Components/ChatFriendList";
import { MessageBox } from "../Components/Chat/ChatInput";
import { MessageComponent, ChatReceive } from "../Components/Chat/ChatBody";
import { getProfile } from "../actions/login";
import {
  addDoc,
  arrayRemove,
  arrayUnion,
  collection,
  deleteDoc,
  deleteField,
  doc,
  getDoc,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  runTransaction,
  serverTimestamp,
  setDoc,
  startAfter,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../Utils/firebase";
import ReceiveChat from "../Components/Chat/ReceiveChat";
import SendChat from "../Components/Chat/SendChat";
import ChatMessageBox from "../Components/Chat/ChatMessageBox";
import { api } from "../actions/api";
import FilePreviewModal from "../Components/Chat/FilePreviewModal";
import GroupAboutSidebar from "../Components/GroupAboutSidebar";
import { FIREBASE_CONVERSATIONS } from "../Utils/constant";
import AddNewMessage from "./AddNewMessage";
import { generateThumbnail } from "../helpers/GenerateThumbnailHelper";
import { formatTime } from "../Utils/helpers";
import { sendFcmNotificationToTopic } from "../helpers/NotificationHelper";
import {
  buildUnreadUserIds,
  clearSenderUnread,
  getUnreadCountForUser,
  isConversationUnreadForUser,
  isLastMessageFromUser,
} from "../Utils/chatUnread";
import useChatAutoScroll from "../hooks/useChatAutoScroll";

const CONVERSATION_PAGE_SIZE = 10;
const MESSAGE_PAGE_SIZE = 20;

export default function Squad() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [currentChatType, setCurrentChatType] = useState(null);
  const [conversationId, setConversationId] = useState(null);
  const [clickedUserInfo, setClickedUserInfo] = useState({
    name: "",
    profileImage: "",
    members: 0,
  });
  const [messages, setMessages] = useState([]);
  const [isMember, setIsMember] = useState(true);
  const [previewFile, setPreviewFile] = useState(null);
  const [currentGroup, setCurrentGroup] = useState();
  const [showAddMessage, setShowAddMessage] = useState(false);
  const [lastDoc, setLastDoc] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);
  const lastMessageDocRef = useRef(null);
  const [hasNext, setHasNext] = useState(true);
  const [autoScrollEnabled, setAutoScrollEnabled] = useState(true);
  const [disabledEditorButton, setDisabledEditorButton] = useState(false);
  const [showUnread, setShowUnread] = useState(false);
  const [replyingTo, setReplyingTo] = useState(null);

  const { scrollContainerRef } = useChatAutoScroll({
    enabled: autoScrollEnabled,
    messages,
    conversationId,
  });

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const profile = await getProfile();
        setUserProfile(profile);
      } catch (error) {
        console.error("Error fetching profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  // useEffect(() => {
  //     if (!userProfile?.id) return;

  //     const userId = String(userProfile.id);

  //     const userConversationsQuery = query(
  //         collection(db, FIREBASE_CONVERSATIONS),
  //         where("participants", "array-contains", String(userProfile.id)),
  //         where("type", "==", "group"),
  //         orderBy("lastMessageTime", "desc")
  //     );

  //     // Set up real-time listener
  //     const unsubscribe = onSnapshot(userConversationsQuery,
  //         (snapshot) => {
  //             const convs = snapshot.docs.map((doc) => ({
  //                 conversationId: doc.id,
  //                 ...doc.data(),
  //             })).filter((data) => data.visibleTo?.includes(userId));
  //             setConversations(convs);
  //             setLoading(false);
  //         },
  //     );

  //     // Cleanup function
  //     return () => unsubscribe();
  // }, [userProfile?.id]);

  useEffect(() => {
    if (!userProfile?.id) return;

    const userId = String(userProfile.id);

    let userConversationsQuery = query(
      collection(db, FIREBASE_CONVERSATIONS),
      where("participants", "array-contains", String(userProfile.id)),
      where("type", "==", "group"),
      orderBy("lastMessageTime", "desc"),
    );

    if (showUnread) {
      userConversationsQuery = query(
        collection(db, FIREBASE_CONVERSATIONS),
        where("unreadUserIds", "array-contains", String(userProfile.id)),
        where("type", "==", "group"),
        orderBy("lastMessageTime", "desc"),
      );
    }

    // Set up real-time listener
    const unsubscribe = onSnapshot(userConversationsQuery, (snapshot) => {
      const convs = snapshot.docs
        .map((doc) => ({
          conversationId: doc.id,
          ...doc.data(),
        }))
        .filter((data) => {
          const isVisible = data.visibleTo?.includes(userId);
          // Safety Backup: Only show group if the user is in participantDetails
          const isInDetails =
            data.participantDetails && userId in data.participantDetails;
          return isVisible && isInDetails;
        });
      setConversations(convs);
      setLoading(false);
    });

    // Cleanup function
    return () => unsubscribe();
  }, [userProfile?.id, showUnread]);

  // Older conversations (manual load, not real-time)
  // const loadMore = async () => {
  //     if (!lastDoc || loading) return;
  //     setLoading(true);

  //     const q = query(
  //         collection(db, FIREBASE_CONVERSATIONS),
  //         where("participants", "array-contains", String(userProfile.id)),
  //         where("type", "==", "group"),
  //         orderBy("lastMessageTime", "desc"),
  //         startAfter(lastDoc),
  //         limit(CONVERSATION_PAGE_SIZE)
  //     );

  //     const snapshot = await getDocs(q);
  //     const more = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

  //     setConversations(prev => [...prev, ...more]);
  //     setLastDoc(snapshot.docs[snapshot.docs.length - 1]);
  //     setLoading(false);
  // };

  // const handleConversationScroll = (e) => {
  //     const el = e.target;

  //     const { scrollTop, clientHeight, scrollHeight } = el;
  //     if (scrollTop + clientHeight >= scrollHeight - 10) {
  //         loadMore();
  //     }
  // }

  const handleFileClick = (file) => {
    setPreviewFile(file);
  };

  const showAddNewMessage = () => {
    setShowAddMessage(true);
  };

  const handleAddNewMessageClose = () => {
    setShowAddMessage(false);
    setConversationId(null); // Reset conversationId here
  };

  const handleDownload = async (file) => {
    if (!file?.url) {
      return;
    }

    try {
      const response = await fetch(file.url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const fileExtension = file.url.split(".").pop().split("?")[0]; // e.g., jpg, png
      const fileName = `downloaded-file.${fileExtension}`;

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(link.href), 150);
    } catch (err) {
      console.error("File download error:", err);
    }
  };

  const handleLike = async (messageId, emoji) => {
    const userId = userProfile.id;
    const messageRef = doc(
      db,
      FIREBASE_CONVERSATIONS,
      conversationId,
      "messages",
      messageId,
    );
    try {
      // Get the current message data to check if already liked
      const messageSnap = await getDoc(messageRef);

      if (!messageSnap.exists()) {
        console.error("Message not found");
        return;
      }

      const messageData = messageSnap.data();
      const currentLikes = messageData.reactions?.like || [];

      // Find if user already reacted with a different emoji
      let previousEmoji = null;
      for (const [key, users] of Object.entries(messageData.reactions)) {
        if (users.includes(String(userId))) {
          previousEmoji = key;
          break;
        }
      }

      const updates = {};

      // If clicking the same emoji again → remove it
      if (previousEmoji === emoji) {
        const updatedUsers = messageData.reactions[emoji].filter(
          (id) => id != userId,
        );

        if (updatedUsers.length === 0) {
          updates[`reactions.${emoji}`] = deleteField();
        } else {
          updates[`reactions.${emoji}`] = updatedUsers;
        }

        await updateDoc(messageRef, updates);
        return;
      }

      // If reacted with a different emoji → remove old one
      if (previousEmoji) {
        const updatedUsers = messageData.reactions[previousEmoji].filter(
          (id) => id != userId,
        );

        if (updatedUsers.length === 0) {
          updates[`reactions.${previousEmoji}`] = deleteField();
        } else {
          updates[`reactions.${previousEmoji}`] = updatedUsers;
        }
      }

      // Add user to the new emoji array
      updates[`reactions.${emoji}`] = arrayUnion(String(userId));

      await updateDoc(messageRef, updates);

      // // Add user to the new emoji array
      // await updateDoc(messageRef, {
      //   [`reactions.${emoji}`]: arrayUnion(String(userId)),
      // });

      // const isLiked = currentLikes.includes(String(userId));

      // if (isLiked) {
      //   // If already liked, remove the like
      //   await updateDoc(messageRef, {
      //     "reactions.like": arrayRemove(String(userId)),
      //   });
      // } else {
      //   // Otherwise, add the like
      //   await updateDoc(messageRef, {
      //     "reactions.like": arrayUnion(String(userId)),
      //   });
      // }
    } catch (error) {
      console.error("Error toggling reactions:", error);
    }
  };

  const handleEdit = (messageId, oldText) => {
    setMessages((prev) =>
      prev.map((msg) =>
        msg.id === messageId ? { ...msg, isEditing: true } : msg,
      ),
    );
  };

  const resetUnreadCountInDB = async (conversationId) => {
    const uid = String(userProfile?.id);
    if (!uid) return;

    const conversationRef = doc(db, FIREBASE_CONVERSATIONS, conversationId);

    try {
      await runTransaction(db, async (transaction) => {
        const convoSnap = await transaction.get(conversationRef);
        if (!convoSnap.exists()) return;

        const convoData = convoSnap.data();
        const currentUnread = convoData.unreadCount || {};

        const updatedUnread = { ...currentUnread, [uid]: 0 };
        const unreadUserIds = buildUnreadUserIds(updatedUnread);

        transaction.update(conversationRef, {
          unreadCount: updatedUnread,
          unreadUserIds,
          lastMessageMentionedIds: arrayRemove(uid),
          updatedAt: serverTimestamp(),
        });
      });
    } catch (error) {
      console.error("Error resetting unread count:", error);
    }
  };

  useEffect(() => {
    if (!conversationId || !userProfile?.id) return;

    const activeConvo = conversations.find(
      (c) => (c.id || c.conversationId) === conversationId,
    );
    if (!activeConvo) return;

    const unread = getUnreadCountForUser(
      activeConvo.unreadCount,
      userProfile.id,
    );
    if (unread > 0) {
      resetUnreadCountInDB(conversationId);
    }
  }, [conversationId, conversations, userProfile?.id]);

  // useEffect(() => {
  //     if (!conversationId) return;
  //     const messagesRef = collection(
  //         db,
  //         FIREBASE_CONVERSATIONS,
  //         conversationId,
  //         "messages"
  //     );

  //     const q = query(
  //         messagesRef,
  //         where("visibleTo", "array-contains", String(userProfile.id)),
  //         orderBy("timestamp", "desc")
  //     );

  //     const unsubscribe = onSnapshot(q, (snapshot) => {
  //         const msgs = snapshot.docs.map((doc) => ({
  //             id: doc.id,
  //             ...doc.data(),
  //         }));
  //         setMessages(msgs);
  //     });

  //     return () => unsubscribe();
  // }, [conversationId]);

  useEffect(() => {
    if (!conversationId) return;
    const messagesRef = collection(
      db,
      FIREBASE_CONVERSATIONS,
      conversationId,
      "messages",
    );

    const q = query(
      messagesRef,
      where("visibleTo", "array-contains", String(userProfile.id)),
      orderBy("timestamp", "desc"),
      limit(MESSAGE_PAGE_SIZE),
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const latest = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        replyCount: doc.data().replyTo?.count || 0,
      }));

      setMessages(latest);

      lastMessageDocRef.current = snapshot.docs[snapshot.docs.length - 1]; // oldest of this page

      setHasNext(snapshot.docs.length === MESSAGE_PAGE_SIZE);
    });

    return () => unsubscribe();
  }, [conversationId]);

  // Load older messages (manual, not real-time)
  const loadOlderMessages = async () => {
    if (!lastMessageDocRef.current || pageLoading || !hasNext) return;
    setPageLoading(true);

    const messagesRef = collection(
      db,
      FIREBASE_CONVERSATIONS,
      conversationId,
      "messages",
    );
    const q = query(
      messagesRef,
      where("visibleTo", "array-contains", String(userProfile.id)),
      orderBy("timestamp", "desc"),
      startAfter(lastMessageDocRef.current),
      limit(MESSAGE_PAGE_SIZE),
    );

    try {
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const older = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMessages((prev) => [...prev, ...older]); // prepend older messages

        lastMessageDocRef.current = snapshot.docs[snapshot.docs.length - 1];
        setHasNext(snapshot.docs.length === MESSAGE_PAGE_SIZE);
      } else {
        setHasNext(false);
      }
    } catch (err) {
      console.error("Error loading older messages:", err);
    } finally {
      setPageLoading(false);
    }
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop == 0) {
      setAutoScrollEnabled(false);
      loadOlderMessages();
    }
  };

  useEffect(() => {
    if (!conversationId) return;
    const groupRef = doc(db, FIREBASE_CONVERSATIONS, conversationId);

    const unsubscribe = onSnapshot(groupRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setCurrentGroup({ id: docSnap.id, ...data });

        // Check membership status
        if (userProfile?.id) {
          const isParticipant =
            data.participants?.includes(String(userProfile.id)) ?? false;
          setIsMember(isParticipant);

          if (!isParticipant && conversationId) {
            // Optional: Redirect or just clear the view?
            // User request: "remove the listing from ... pages where the friend or groups are listed"
            // "And also if the User D has opened the chat... he should automatically receive 'You can't send...'"
            // The listener in Chat.jsx/Squad.jsx handles the "open chat" part.
            // The list update relies on visibleTo/participants filter in the main list query.
            // So here we mostly care about the "open chat" UI state.
          }
        }
      } else {
        setCurrentGroup(null);
        setIsMember(false);
      }
    });

    return () => unsubscribe();
  }, [conversationId]);

  const handleSelectUser = async (
    conversationId,
    type,
    profileImage,
    name,
    members,
  ) => {
    setCurrentChatType(type);
    setConversationId(conversationId);
    setClickedUserInfo({
      profileImage: profileImage,
      name: name || "Squad",
      members: members || 0,
    });
    setShowAddMessage(false);

    await resetUnreadCountInDB(conversationId);
  };

  const handleSaveEdit = async (
    messageId,
    newContent,
    file,
    mentionedIds = [],
  ) => {
    try {
      const messageRef = doc(
        db,
        FIREBASE_CONVERSATIONS,
        conversationId,
        "messages",
        messageId,
      );
      await updateDoc(messageRef, {
        content: newContent,
        mentionedIds: mentionedIds || [],
      });

      // Update lastMessageMentionedIds on conversation if it's the last message
      const convoRef = doc(db, FIREBASE_CONVERSATIONS, conversationId);
      const convoSnap = await getDoc(convoRef);
      if (convoSnap.exists()) {
        const convoData = convoSnap.data();
        // Fallback check if lastMessage exactly matches the old content
        if (
          convoData.lastMessage ===
          messages.find((m) => m.id === messageId)?.content
        ) {
          await updateDoc(convoRef, {
            lastMessage: newContent,
            lastMessageMentionedIds: mentionedIds || [],
          });
        }
      }

      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === messageId ? { ...msg, isEditing: false } : msg,
        ),
      );
    } catch (error) {
      console.error("Failed to save edited message:", error);
      // Optionally, you can revert the state change if saving fails
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === messageId ? { ...msg, isEditing: true } : msg,
        ),
      );
    }
  };

  const handleCancelEdit = (messageId) => {
    setMessages((prev) =>
      prev.map((msg) =>
        msg.id === messageId ? { ...msg, isEditing: false } : msg,
      ),
    );
  };

  const handleDeleteMessage = async (messageId) => {
    try {
      const messageRef = doc(
        db,
        FIREBASE_CONVERSATIONS,
        conversationId,
        "messages",
        messageId,
      );

      await updateDoc(messageRef, {
        visibleTo: arrayRemove(String(userProfile?.id)),
      });

      const messageSnap = await getDoc(messageRef);
      if (messageSnap.exists()) {
        const data = messageSnap.data();
        if (!data.visibleTo || data.visibleTo.length === 0) {
          await deleteDoc(messageRef);
        }
      }

      // 2. Update local state
      setMessages((prev) => prev.filter((msg) => msg.id !== messageId));
    } catch (error) {
      console.error("Failed to delete message:", error);
    }
  };

  const handleSendMessage = async (content, file, mentionedIds = []) => {
    setAutoScrollEnabled(true);

    let fileData = null;
    let newMessageId = null;

    if (file) {
      fileData = await handleSendFile(file);
    }

    try {
      const convoRef = doc(db, FIREBASE_CONVERSATIONS, conversationId);
      const convoSnap = await getDoc(convoRef);

      if (!convoSnap.exists()) {
        console.error("Conversation not found");
        return;
      }
      const convoData = convoSnap.data();
      const visibleToUserIds = convoData.participants || [];

      if (replyingTo) {
        setDisabledEditorButton(true);
        // This is a reply - store it in threads subcollection
        const threadMessageData = {
          type: "text",
          metadata: {},
          reactions: {},
          isRead: null,
          senderId: userProfile.id,
          senderName: userProfile.full_name,
          senderProfileImage: userProfile.image,
          timestamp: serverTimestamp(),
          content: content,
          isFile: !!fileData,
          visibleTo: visibleToUserIds,
          mentionedIds: mentionedIds || [],
        };

        if (fileData) {
          threadMessageData.file = {
            url: fileData.media_url || null,
            type: fileData.type || null,
          };
        }

        const threadRef = doc(db, "threads", replyingTo.id);
        const threadSnap = await getDoc(threadRef);

        let threadExists = true;

        // Update the original message to increment reply count and set first message
        const originalMessageRef = doc(
          db,
          FIREBASE_CONVERSATIONS,
          conversationId,
          "messages",
          replyingTo.messageId,
        );

        await runTransaction(db, async (transaction) => {
          const originalMsgSnap = await transaction.get(originalMessageRef);

          if (originalMsgSnap.exists()) {
            const originalMsgData = originalMsgSnap.data();

            if (!threadSnap.exists()) {
              threadExists = false;
              await setDoc(threadRef, {
                createdAt: serverTimestamp(),
                id: replyingTo.id,
                visibleTo: visibleToUserIds,
                mainMessage: originalMsgData,
                conversationId: conversationId,
              });
            }

            if (!threadExists) {
              await addDoc(
                collection(db, "threads", replyingTo.id, "messages"),
                originalMsgData,
              );
            }

            const currentReplyTo = originalMsgData.replyTo || { count: 0 };

            transaction.update(originalMessageRef, {
              replyTo: {
                id: `${replyingTo.id}`,
                count: (currentReplyTo.count || 0) + 1,
                message: content,
              },
            });
          }
        });

        // Add the reply to threads
        const newMessageRef = await addDoc(
          collection(db, "threads", replyingTo.id, "messages"),
          threadMessageData,
        );
        newMessageId = newMessageRef.id;
      } else {
        const messageData = {
          type: "text",
          metadata: {},
          reactions: {},
          isRead: null,
          senderId: userProfile.id,
          senderName: userProfile.full_name,
          senderProfileImage: userProfile.image,
          timestamp: serverTimestamp(),
          content: content,
          isFile: !!fileData, // true or false
          visibleTo: visibleToUserIds,
          mentionedIds: mentionedIds || [],
        };

        if (fileData) {
          messageData.file = {
            thumbnail: fileData.media_url || null,
            url:
              fileData.video_url ||
              fileData.media_url ||
              fileData.audio_url ||
              null,
            type: fileData.type || null,
          };
        }

        const newMessageRef = await addDoc(
          collection(db, FIREBASE_CONVERSATIONS, conversationId, "messages"),
          messageData,
        );
        newMessageId = newMessageRef.id;
      }

      await runTransaction(db, async (transaction) => {
        const convoSnap = await transaction.get(convoRef);
        if (!convoSnap.exists()) return;

        const convoData = convoSnap.data();

        const currentUnread = convoData.unreadCount || {};
        // Use only participants (not visibleTo) to avoid re-adding removed members
        const allParticipants = (convoData.participants || []).filter(Boolean);

        // A new message brings the conversation back for participants who
        // removed themselves via "delete for me", so re-add them to visibleTo
        // (removed group members are not in participants and stay out).
        const updatedVisibleTo = Array.from(
          new Set([
            ...(convoData.visibleTo || []).map(String),
            ...allParticipants.map(String),
          ]),
        );

        const updatedUnread = { ...currentUnread };

        // Ensure every participant exists in unreadCount and increment if pass sanity check
        allParticipants.forEach((uid) => {
          const uidStr = String(uid);

          const isNotSender = uidStr !== String(userProfile.id);
          const isVisible = updatedVisibleTo.includes(uidStr);
          const isInDetails =
            convoData.type === "group"
              ? convoData.participantDetails &&
                uidStr in convoData.participantDetails
              : true;

          if (isNotSender && isVisible && isInDetails) {
            if (!(uidStr in updatedUnread)) {
              updatedUnread[uidStr] = 0;
            }
            updatedUnread[uidStr] = (updatedUnread[uidStr] || 0) + 1;
          }
        });

        clearSenderUnread(updatedUnread, userProfile.id);

        const unreadUserIds = buildUnreadUserIds(updatedUnread);

        transaction.update(convoRef, {
          lastMessage: content,
          lastMessageSenderId: String(userProfile.id),
          lastMessageTime: serverTimestamp(),
          updatedAt: serverTimestamp(),
          unreadCount: updatedUnread,
          unreadUserIds,
          participants: allParticipants, // Fix broken participants list
          visibleTo: updatedVisibleTo,
          lastMessageMentionedIds: mentionedIds || [],
          // Track if last message is from a thread for navigation
          lastMessageThreadId: replyingTo ? replyingTo.id : null,
        });
      });

      const convoSnapAfter = await getDoc(convoRef);
      const convoDataAfter = convoSnapAfter.data();
      const allParticipants = (convoDataAfter.participants || []).filter(
        Boolean,
      );

      // Send Push Notification
      // Squad chats are always group chats in this file
      const notificationTitle = `${userProfile.full_name} in ${convoDataAfter.metadata?.groupName || "Squad"}`;

      sendFcmNotificationToTopic({
        title: notificationTitle,
        body: content || (fileData ? "Attachment" : ""),
        conversationId: conversationId,
        threadId: replyingTo ? replyingTo.id : null,
        isGroupChat: true,
        recipientIds: allParticipants,
        senderId: userProfile.id,
        messageId: newMessageId || `${conversationId}_${Date.now()}`,
      });
    } catch (error) {
      console.error("Failed to send message:", error);
    } finally {
      setDisabledEditorButton(false);
    }
  };

  const chunkSize = 5 * 1024 * 1024; // 5MB per chunk

  function generateRandomString(length) {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  const uploadFileInChunks = async (file, fileId) => {
    const totalChunks = Math.ceil(file.size / chunkSize);

    for (let chunkNumber = 1; chunkNumber <= totalChunks; chunkNumber++) {
      const start = (chunkNumber - 1) * chunkSize;
      const end = Math.min(file.size, start + chunkSize);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append("file_id", fileId);
      formData.append("chunk_number", chunkNumber);
      formData.append("total_chunks", totalChunks);
      formData.append("file_name", file.name);
      formData.append("chunk", chunk);
      await api.post("/upload-chunk", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    }
  };

  const handleSendFile = async (file) => {
    setLoading(true);
    setDisabledEditorButton(true);
    try {
      // Convert audio to MP3 before upload
      if (
        file &&
        file.type &&
        file.type.startsWith("audio") &&
        file.type !== "audio/mpeg"
      ) {
        try {
          const convertToMp3 = (await import("../Utils/convertToMp3")).default;
          const mp3File = await convertToMp3(file);
          if (mp3File) file = mp3File;
        } catch (err) {
          console.warn(
            "convertToMp3 failed in Squad, proceeding with original file",
            err,
          );
        }
      }
      const formData = new FormData();

      const uploadedVideoIds = [];

      try {
        if (file.type.startsWith("video")) {
          const fileId = generateRandomString(10);
          await uploadFileInChunks(file, fileId);
          uploadedVideoIds.push(fileId);

          // Generate thumbnail for mobile
          const thumbnail = await generateThumbnail(file);

          if (thumbnail) {
            formData.append("media", thumbnail);
          }
        } else if (file.type.startsWith("audio")) {
          formData.append("audio", file);
        } else {
          formData.append("media", file);
        }

        // 2. Append videoIds once after loop
        if (uploadedVideoIds.length > 0) {
          formData.append("videoIds", JSON.stringify(uploadedVideoIds));
        }
      } catch (e) {
        setLoading(false);
      }

      const response = await api.post("/user/chat/media/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!response.status == 200) {
        throw new Error("Upload failed");
      }

      const fileData = response.data;

      setLoading(false);
      return fileData;
    } catch (error) {
      console.error("Error uploading file:", error);
      setLoading(false);
    }
  };

  const handleDeleteConversation = async (conversationId) => {
    let result = window.confirm("Are you sure you want to Delete?");
    if (!result) return;
    const convoRef = doc(db, FIREBASE_CONVERSATIONS, conversationId);
    const messagesRef = collection(
      db,
      FIREBASE_CONVERSATIONS,
      conversationId,
      "messages",
    );

    await updateDoc(convoRef, {
      visibleTo: arrayRemove(String(userProfile?.id)),
      deletedBy: arrayUnion(String(userProfile?.id)),
    });

    // Check if conversation is now empty
    const convoSnap = await getDoc(convoRef);
    if (!convoSnap.exists()) return;

    const data = convoSnap.data();
    if (!data.visibleTo || data.visibleTo.length === 0) {
      const querySnap = await getDocs(messagesRef);

      querySnap.forEach(async (msgDoc) => {
        await deleteDoc(msgDoc.ref);
      });

      await deleteDoc(convoRef); // fully remove
    }

    setConversationId(null);
  };

  const handleReply = (message) => {
    setReplyingTo({
      id: message.conversationId + "_" + message.id,
      count: 1,
      messageId: message.id,
      parentMessage: {
        content: message.content,
        userImage: message.userImage,
        owner: userProfile?.full_name,
      },
    });
  };

  const handleCancelReply = () => {
    setReplyingTo(null);
  };

  return (
    <>
      <Layout showHeader={false}>
        <div className="page-content h-100 chat-main">
          <div className="setting-content">
            <div className="d-flex align-items-center gap-2 pages-title-container">
              <img className="sidebar-toggle" src="/icons/menu.svg" />
              <h1 className="pages-header text-heading-h2 mb-0">Chats</h1>
            </div>
            <div className="user-chats-card users-chat-card-components">
              <div className="d-flex w-100">
                <div
                  className="chat-friend-list-container flex-shrink-0 w-100"
                  // onScroll={handleConversationScroll}
                  style={{ maxWidth: "350px" }}
                >
                  <ChatFriendList
                    chatItems={conversations.map((item) => {
                      const userId = String(userProfile?.id);
                      const itemType = item.type;
                      const conversationKey = item.id || item.conversationId;

                      const otherParticipantId =
                        itemType === "direct"
                          ? item.participants.find((id) => id !== userId)
                          : null;

                      const otherParticipant =
                        itemType === "direct"
                          ? item.participantDetails?.[otherParticipantId]
                          : null;
                      const isUserLastMessage = isLastMessageFromUser(
                        item.lastMessageSenderId,
                        userId,
                      );

                      const otherSenderName =
                        !isUserLastMessage && item.lastMessageSenderId
                          ? item.participantDetails?.[item.lastMessageSenderId]
                              ?.name
                          : null;

                      const unreadCount = getUnreadCountForUser(
                        item.unreadCount,
                        userId,
                      );

                      return {
                        conversationId: conversationKey,
                        name:
                          itemType === "group"
                            ? item.metadata?.groupName
                            : otherParticipant?.name || "Unknown",
                        profileImage:
                          itemType === "group"
                            ? null
                            : otherParticipant?.profileImage || null,
                        lastMessage: item.lastMessage,
                        isUserLastMessage: isUserLastMessage,
                        lastMessageTime: item.lastMessageTime,
                        otherSenderName: otherSenderName,
                        unreadCount,
                        isUnread: isConversationUnreadForUser(
                          item.unreadCount,
                          userId,
                        ),
                        type: itemType,
                        isGroup: itemType === "group",
                        members:
                          itemType === "group"
                            ? item.participants.length
                            : undefined,
                        // isOnline:
                        //     itemType === "direct"
                        //         ? onlineStatusMap[otherParticipantId]
                        //         : undefined,
                      };
                    })}
                    onSelectUser={(
                      conversationId,
                      type,
                      profileImage,
                      name,
                      members,
                    ) => {
                      handleSelectUser(
                        conversationId,
                        type,
                        profileImage,
                        name,
                        members,
                      );
                    }}
                    onDeleteConversation={(conversationId) => {
                      handleDeleteConversation(conversationId);
                    }}
                    handleAddClick={showAddNewMessage}
                    showUnreadConversations={() => setShowUnread(!showUnread)}
                    showUnread={showUnread}
                    activeConversation={conversationId}
                  />
                </div>
                {showAddMessage ? (
                  <AddNewMessage
                    setShowAddMessage={handleAddNewMessageClose}
                    onChatCreated={handleSelectUser}
                  />
                ) : conversationId ? (
                  <>
                    <div className="flex-grow-1 flex-column chats-contents active-chat">
                      <div className="d-flex justify-content-between chats-card-content align-items-center">
                        <div className="d-flex align-items-center gap-2">
                          {/* <div className="back-arrow-for-chats">
                                            <img
                                                className="chats-back-arrow"
                                                src="/icons/back-arrow.svg"
                                            />
                                        </div> */}
                          <div className="chat-profile-image-user">
                            <img
                              className="chat-profile-self-img"
                              src={
                                currentChatType === "group"
                                  ? "/icons/group-user.svg"
                                  : clickedUserInfo.profileImage
                              }
                              alt=""
                            />
                            <span
                              className="text-heading-h3"
                              style={{ color: "#d0d8df" }}
                            >
                              {clickedUserInfo.name}
                              {currentChatType === "group" && (
                                <span
                                  className="text-body-b2"
                                  style={{
                                    marginLeft: "8px",
                                    color: "#b3ddff",
                                  }}
                                >
                                  ({clickedUserInfo.members} members)
                                </span>
                              )}
                            </span>
                          </div>
                        </div>
                        {/* <div className="">
                                        <div className="chat-profile-image-user">
                                            <img src="/icons/download-icon.svg" alt="" />
                                            <span
                                                className="text-body-b2 dwn-text"
                                                style={{ color: "#b3ddff" }}
                                            >
                                                Download
                                            </span>
                                        </div>
                                    </div> */}
                      </div>
                      <div className="chat-container d-flex flex-column flex-grow-1">
                        <div
                          className="no-scrollbar mt-auto d-flex flex-column flex-grow-1"
                          style={{ height: "0px", minHeight: "0px" }}
                        >
                          <div
                            className="chat-container d-flex flex-column flex-grow-1"
                            style={{
                              overflowY: "auto",
                              flexGrow: 1, // fill remaining space below header
                              minHeight: 0, // important for flexbox scroll to work correctly
                              padding: "12px 16px",
                              // background: "#12161f", // optional, for contrast
                            }}
                          >
                            <div
                              ref={scrollContainerRef}
                              className="no-scrollbar mt-auto d-flex flex-column flex-grow-1"
                              style={{ overflowY: "auto", height: "90%" }}
                              onScroll={handleScroll}
                            >
                              <div className="message-group">
                                {[...messages].reverse().map((msg) => {
                                  if (msg.senderId == userProfile?.id) {
                                    return (
                                      <React.Fragment key={`sent-${msg.id}`}>
                                        <ReceiveChat
                                          key={`sent-${msg.id}`}
                                          response={msg.content}
                                          responder={
                                            userProfile?.id == msg.senderId
                                              ? "You"
                                              : msg.senderName
                                          }
                                          time={formatTime(msg.timestamp)}
                                          userImage={
                                            userProfile?.image ||
                                            "/icons/james.svg"
                                          }
                                          userId={msg.senderId}
                                          isFile={msg.isFile}
                                          fileInfo={msg?.file}
                                          fileType={msg?.file?.type}
                                          isUploading={msg.isUploading}
                                          uploadProgress={msg.uploadProgress}
                                          onDownload={() =>
                                            handleFileClick(msg?.file)
                                          }
                                          messageId={msg.id}
                                          isEditing={msg.isEditing}
                                          disableEdit={msg.disableEdit}
                                          onLike={handleLike}
                                          // isLiked={msg.reactions?.like?.includes(String(userProfile?.id)) || false}
                                          reactionSummary={msg.reactions || {}}
                                          isLiked={
                                            Array.isArray(msg.reactions?.like)
                                              ? msg.reactions.like.length > 0
                                              : false
                                          }
                                          onEdit={handleEdit}
                                          // onReply={handleReply}
                                          onSaveEdit={handleSaveEdit}
                                          onCancelEdit={handleCancelEdit}
                                          onDelete={handleDeleteMessage}
                                          showReply={true}
                                          replyCount={msg.replyTo?.count || 0}
                                          conversationId={conversationId}
                                          onReply={handleReply}
                                          journal={msg?.journal ?? {}}
                                        />
                                      </React.Fragment>
                                    );
                                  } else {
                                    return (
                                      <SendChat
                                        key={`received-${msg.id}`}
                                        username={msg.senderName}
                                        title={msg.content}
                                        time={formatTime(msg.timestamp)}
                                        // botImage="/icons/james.svg"
                                        userImage={
                                          msg.senderProfileImage ||
                                          "/icons/james.svg"
                                        }
                                        senderId={msg.senderId}
                                        isFile={msg.isFile}
                                        fileInfo={msg?.file}
                                        fileType={msg?.file?.type}
                                        onDownload={() =>
                                          handleFileClick(msg?.file)
                                        }
                                        messageId={msg.id}
                                        onLike={handleLike}
                                        reactionSummary={msg.reactions || {}}
                                        // isLiked={msg.reactions?.like?.includes(String(userProfile?.id)) || false}
                                        isLiked={
                                          Array.isArray(msg.reactions?.like)
                                            ? msg.reactions.like.length > 0
                                            : false
                                        }
                                        showReply={true}
                                        replyCount={msg.replyTo?.count || 0}
                                        conversationId={conversationId}
                                        onReply={handleReply}
                                        journal={msg?.journal ?? {}}
                                      />
                                    );
                                  }
                                })}
                              </div>
                            </div>

                            {!messages?.some((msg) => msg.isEditing) &&
                            !replyingTo ? (
                              <>
                                {!isMember && (
                                  <div
                                    className="p-3 mb-2 text-center text-white"
                                    style={{
                                      backgroundColor: "#EB5757",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    You can't send messages to this group
                                    because you're no longer a member.
                                  </div>
                                )}
                                {isMember && (
                                  <div className="message-box-container">
                                    <ChatMessageBox
                                      conversationId={conversationId}
                                      userProfile={userProfile}
                                      onSendClick={handleSendMessage}
                                      onSendFile={handleSendFile}
                                      // disabled={!isClientReady}
                                      disabledButton={disabledEditorButton}
                                      participants={
                                        currentGroup?.participantDetails
                                      }
                                    />
                                  </div>
                                )}
                              </>
                            ) : !messages?.some((msg) => msg.isEditing) &&
                              replyingTo ? (
                              // Reply mode message box
                              <ChatMessageBox
                                conversationId={conversationId}
                                userProfile={userProfile}
                                onSendClick={handleSendMessage}
                                onSendFile={handleSendFile}
                                replyingTo={replyingTo}
                                onCancelReply={handleCancelReply}
                                disabledButton={disabledEditorButton}
                                participants={currentGroup?.participantDetails}
                              />
                            ) : (
                              <ChatMessageBox
                                conversationId={conversationId}
                                userProfile={userProfile}
                                onSendClick={(newContent, file, mentionedIds) =>
                                  handleSaveEdit(
                                    messages.find((msg) => msg.isEditing)?.id,
                                    newContent,
                                    file,
                                    mentionedIds,
                                  )
                                }
                                initialText={
                                  messages.find((msg) => msg.isEditing)
                                    ?.content || ""
                                }
                                isEditing={true}
                                onCancel={() =>
                                  handleCancelEdit(
                                    messages.find((msg) => msg.isEditing)?.id,
                                  )
                                }
                                // disabled={!isClientReady}
                                showFileUpload={false}
                                disabledButton={disabledEditorButton}
                                participants={currentGroup?.participantDetails}
                              />
                            )}
                          </div>
                        </div>
                        {/* message box */}
                        {/* <MessageBox onSendClick={handleSendMessage} /> */}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="d-flex justify-content-center align-items-center h-100 w-100">
                    <div className="text-center">
                      <h3>Select a chat to start messaging</h3>
                      <p>
                        Choose a contact or group from the list to begin
                        conversation
                      </p>
                    </div>
                  </div>
                )}
                {/* right side */}
                {conversationId && (
                  <GroupAboutSidebar
                    conversationId={conversationId}
                    userProfile={userProfile}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </Layout>
      <FilePreviewModal
        file={previewFile}
        onClose={() => setPreviewFile(null)}
        onDownload={handleDownload}
      />
    </>
  );
}
